import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import PatientSave from '../../user/patient/PatientSave';

const dialogStyle = {
    width: '70%',
    maxWidth: 'none'
};

class POSPatientSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {

        };

    }

    render() {
        const { t } = this.props; 
        return (
            
            <DialogInput
                title={<DialogHeaderWithClose text={t('pos.patientSave.viewMember')} handleClose={() => this.props.onCancel()}/>}
                modal={true}
                open={this.props.isOpen}
                autoScrollBodyContent={true}
                className="transfer_Product checkIn_list memberDialogPOSScreen"
                handleClose={() => this.props.onCancel()}
                contentStyle={dialogStyle}>
                <div className="no-crumb">
                    <PatientSave patientId={this.props.patientId} isDialog={true} closeDialog={() => this.props.onCancel()} />
                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSPatientSave));